// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../../engines/gameEngine";
import utilsView from "../../../../../engines/libs/utilsView";
import { FileKind } from "../../../../define/FileKind";
import ModelDialogLayer from "../../../../gameCommon/basic/ModelDialogLayer";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SettleLawsuitLayer extends BasePopUpLayer {
   
    resetData() {
        
    }

    againStart() {
        this.resetData();
    }

    closeLayer() {
        this.destroyNode();
    }

    onClickExit() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        ModelDialogLayer.show('确定退出衙门吗？', null, ()=> {
            this.closeLayer();
        });
    }

    openLoseLayer(retArr: string[], prefabFile: FileKind.PrefabFileInfo) {
        utilsView.openPopupLayerTwo(
            prefabFile
            , null
            , {
                retArr: retArr
                , parent: this
            }
        );
    }

    openSuccessLayer(
        retArr: string[]
        , prefabFile: FileKind.PrefabFileInfo
        , dataPlus?: any
    ) {
        let data = {
            retArr: retArr
            , parent: this
        }
        if (dataPlus) {
            Object.assign(data, dataPlus);
        }
        utilsView.openPopupLayerTwo(
            prefabFile
            , null
            , data
        );
    }

    // update (dt) {}
}
